import React, { Component } from 'react';
import { Button, Layout, message } from 'antd';
import { API_AUTH } from '../../config';
import { withTranslation } from 'react-i18next';
import { FilePdfOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { getNetwork } from '../../utils/getNetwork';
const { Header } = Layout;

const INSTRUCTION_FILES = {
  ru: '/docs/instruction_admin_ru.pdf',
  kz: '/docs/instruction_admin_kz.pdf',
};

class HeaderComponent extends Component {
  constructor() {
    super();

    this.state = {
      user: {},
    };
  }

  componentDidMount() {
    const userAsJSON = localStorage.getItem('ccAdmin.currentUser');
    const currentUser = JSON.parse(userAsJSON);
    this.setState({ user: currentUser });
  }

  logOut() {
    getNetwork().get(`${API_AUTH}/logout`).then(() => {
      message.success('Вы вышли с аккаунта');
      localStorage.removeItem('ccAdmin.currentUser');
      localStorage.removeItem('modules');
      window.location.href = '/#/login';
    });
    localStorage.removeItem('formReport');
    localStorage.removeItem('reportsStash');
    localStorage.removeItem('formCreateReport');
    localStorage.removeItem('initialReports');
  }

  render() {
    const { t, i18n, collapsed, handleCollapseMenu } = this.props;
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
    };
    return (
      <Header className="header">
        <div className="header__inner">
          <div className="header__left">
            <Button
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              size={20}
              onClick={handleCollapseMenu}
            />
            <div className="logo header__title">
              <h3 style={{ margin: 0 }} className="color-white">{t('main.SCcontrolPanel')}</h3>
            </div>
          </div>

          <div className="header__actions">
            {this.state.user.userFIO && (
              <span className="header__user" title={this.state.user.userFIO}>
                {this.state.user.userFIO}
              </span>
            )}
            <a
              className="header__action"
              href={INSTRUCTION_FILES[i18n.language] || INSTRUCTION_FILES.ru}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FilePdfOutlined />
              {t('main.instruction')}
            </a>
            <span
              className={`header__action${i18n.language === 'ru' ? ' header__action--active' : ''}`}
              onClick={() => changeLanguage('ru')}
            >
              РУС
            </span>
            <span
              className={`header__action${i18n.language === 'kz' ? ' header__action--active' : ''}`}
              onClick={() => changeLanguage('kz')}
            >
              ҚАЗ
            </span>
            <span className="header__action" onClick={() => this.logOut()}>
              {t('main.exit')}
            </span>
          </div>
        </div>
      </Header>
    );
  }
}
export default withTranslation()(HeaderComponent);
